import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';

const StatusChangeDropdown = ({
  flyToWorkTicketInfo,
  setFlyToWorkTicketInfo,
  confirmedStatus,
  filteredStatus,
  getFollowingStatusOptions,
  darkMode,
  getReactSelectStyles,
}) => {
  const isConfirmed = flyToWorkTicketInfo?.followingStatus?.toLowerCase() === 'confirmed';

  return (
    <Row className="mb-3">
      {isConfirmed && (
        <Col md={{ span: 3, offset: 6 }}>
          <Select
            options={confirmedStatus}
            isClearable
            menuPlacement="top"
            onChange={(e) => {
              setFlyToWorkTicketInfo({ ...flyToWorkTicketInfo, confirmedStatus: e?.value || '' });
            }}
            styles={getReactSelectStyles(darkMode)}
          />
        </Col>
      )}
      <Col md={isConfirmed ? 3 : { span: 4, offset: 8 }}>
        <Select
          options={getFollowingStatusOptions()}
          isClearable
          menuPlacement="top"
          onChange={(e) => {
            setFlyToWorkTicketInfo({
              ...flyToWorkTicketInfo,
              followingStatus: e?.value || '',
              confirmedStatus: e ? flyToWorkTicketInfo.confirmedStatus : '',
            });
          }}
          value={filteredStatus.find((s) => s.value === flyToWorkTicketInfo?.followingStatus?.toLowerCase()) || null}
          styles={getReactSelectStyles(darkMode)}
        />
      </Col>
    </Row>
  );
};

export default StatusChangeDropdown;
